import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
//===--- Main
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
//===--- Data
import MenuItems from './data/menuItems';
import GIFT_CARDS from './data/giftCardItems';

export default function Account(props) {
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    let key = parseInt(hashParams.get('item'));
    let other = hashParams.get('other') === 'true';
    if (other) {
        if (key > 4 || key <= 0) key = 1
    } else {
        if (key > 25 || key <= 0) key = 1
    }
    

    const FullMenu = MenuItems.flatMap(category => Object.values(category).flat());
    let item = other ? GIFT_CARDS.find(item => item.key === key) : FullMenu.find(item => item.key === key);

    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const handleSubmit = (event) => {
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        props.progress < 100 ? props.setProgress(props.progress + 10) : props.setProgress(0);
        //navigate(`/menu/product?item=${key}&other=${other}`);
        alert(`Successfully purchased ${item.title}! 10 Points have been added to your account`)
        navigate('/menu');
      }
  
      setValidated(true);
    };
    function handleClick() {
        props.setProgress(0);
        alert(`Successfully purchased ${item.title} using rewards!`)
        navigate('/menu');
    }
    const numbersM = Array.from({ length: 12 }, (_, index) => index + 1);
    const Month = numbersM.map( (num) => {
      return (
        <option value={num}>{num}</option>
      )
    })
    const currentYear = new Date().getFullYear();
    const numbersY = Array.from({ length: 21 }, (_, index) => currentYear + index);
    const Year = numbersY.map( (num) => {
        return (
          <option value={num}>{num}</option>
        )
      })
      function ScrollTo(e) {
        const elem = document.getElementById(e);
        const rect = elem.getBoundingClientRect();
        const yPos = rect.top;
    
    
        window.scrollTo(0, yPos);
      }
    
    return (
    <section id='product'>
        <div className='banner'>
            <Container>
                {(other || key > 17) ? <Image className='other' alt={item.title} src={item.img} fluid /> : <Image alt={item.title} src={item.img} fluid />}
                <Col>
                    <h2>{item.title}</h2>
                    <h6 className='mb-2 text-muted' data-bs-theme='dark'>{item.calories}</h6>
                    <p>{item.price}</p>
                    <Button variant="outline-light" size="sm" onClick={()=>(ScrollTo('purchase'))}>Purchase</Button>
                </Col>
            </Container>
        </div>
        {!other && <div className="row-items bg-body-tertiary alt">
            <Container className="alt-container">
                <Row>
                        <h3>Description</h3>
                        <p>{item.desc}</p>
                </Row>
                <Row>
                        <h3>Ingredients</h3>
                        <p>{item.ingredients}</p>
                </Row>
            </Container>
        </div>}
        <div className="row-items">
            {!other && <Container className='cos'>
                <div className='head'>
                    <h3>Customize Item</h3>
                </div>
                <hr />
                {(item.key < 17) ? <Col className='sin'> 
                <FloatingLabel controlId="floating" label="Size">
                    <Form.Select aria-label="Default select example" size='lg'>
                        <option>Choose</option>
                        <option value="1">Small</option>
                        <option value="2">Medium</option>
                        <option value="3">Large</option>
                    </Form.Select>
                </FloatingLabel>
                <FloatingLabel controlId="floating" label="Ice">
                    <Form.Select aria-label="Default select example" size='lg'>
                        <option value="">Choose</option>
                        <option value="1">Regular Ice</option>
                        <option value="2">Less Ice</option>
                        <option value="3">No Ice</option>
                    </Form.Select>
                </FloatingLabel>
                <FloatingLabel controlId="floating" label="Sweetness">
                    <Form.Select aria-label="Default select example" size='lg'>
                        <option value="">Choose</option>
                        <option value="1">Regular Sweetness</option>
                        <option value="2">Less Sweet</option>
                        <option value="3">Half Sweet</option>
                        <option value="4">Quarter Sweet</option>
                        <option value="5">No Sweetness</option>
                    </Form.Select>
                </FloatingLabel>
                <FloatingLabel controlId="floating" label="Boba">
                    <Form.Select aria-label="Default select example" size='lg'>
                        <option value="">Choose</option>
                        <option value="1">Regular Boba</option>
                        <option value="3">Popping Boba</option>
                        <option value="2">Mini Boba</option>
                        <option value="4">Lychee</option>
                        <option value="5">Jelly</option>
                    </Form.Select>
                </FloatingLabel> </Col> : <Col className='sin'>
                <FloatingLabel controlId="floating" label="Item">
                    <Form.Select aria-label="Default select example" size='lg' disabled>
                        <option>Unavailable</option>
                    </Form.Select>
                </FloatingLabel>
                </Col>}
            </Container>}
            <Container className='cos'>
                <div id='purchase' className='head'>
                    {props.isSignedIn ? <h3>Billing Information</h3> : <h3>Guest Billing Information</h3>}
                </div>
                <hr />
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group as={Col} className='form-group' controlId="validationCustom01">
                        <FloatingLabel controlId="floatingInput" label="Card number">
                            <Form.Control
                                required
                                type="text"
                                placeholder="XXXX-XXXX-XXXX-XXXX"
                                defaultValue=""
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type='invalid'>Enter all numbers of the card</Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} className='form-group' controlId="validationCustom02">
                        <FloatingLabel controlId="floatingInput" label="Name on card">
                            <Form.Control
                            required
                            type="text"
                            placeholder="First Name"
                            defaultValue=""
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type='invalid'>Enter the name on the card</Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} className='form-group' controlId="validationCustom03">
                        <FloatingLabel controlId="floating" label="Exparation Month">
                            <Form.Select aria-label="Default select example" size='lg' required>
                                <option value="">Choose</option>
                                {Month}
                            </Form.Select>
                        </FloatingLabel>
                        <FloatingLabel controlId="floating" label="Exparation Year">
                            <Form.Select aria-label="Default select example" size='lg' required>
                                <option value="">Choose</option>
                                {Year}
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                    <Button type='outline-dark submit' variant='dark'>Purchase Now</Button>
                    {(props.progress === 100) && <Button variant='outline-dark' onClick={handleClick}>Use Reward</Button>}
                </Form>
                
            </Container>
        </div>
    </section>
  );
}